import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * COMMS-17: "you and someone else are both editing this paragraph" — was
 * silent before; the losing author's edit to this exact paragraph could
 * vanish on the next reconcile with zero indication. Not a merge UI (a full
 * OT/CRDT block merge is out of scope) — it makes the conflict visible so the
 * author can re-apply their change if it is the one that was dropped.
 * (Moved out of DocumentEditorTab.js, documents redesign 13.10.2026.)
 */
export default function CollabConflictBanner({ onDismiss }) {
  const { t } = useTranslation();
  return (
    <div role="status" aria-live="polite" className="doc-editor-collab-conflict-banner">
      <span>{t('docEditor.collabConflict')}</span>
      <button type="button" onClick={onDismiss} aria-label={t('docEditor.dismiss')} className="doc-editor-collab-conflict-dismiss">
        {t('docEditor.dismiss')}
      </button>
    </div>
  );
}
